import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { TextField, Loadable, CheckBox, If } from "components/support";

class CompanyFormGeneralInfo extends Component {
  constructor(props) {
    super(props);
    props.viewModel.company = props.company;
  }

  handleCnpjChange = value => {
    this.props.company.fiscal_informations.cnpj = value;
    this.props.presenter.onCnpjChange();
  };

  render() {
    const { company, errors, presenter, viewModel } = this.props;
    const { loading, currentUser } = viewModel;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <div className="grid-container mt-sm mb-sm">
                <If test={currentUser.is_admin}>
                  <Row>
                    <Col xs={12}>
                      <CheckBox
                        style={{ padding: "10px 0px 0px 0px" }}
                        checked={company.blocked}
                        label="Bloquear Empresa"
                        onCheck={checked => presenter.onEnabledChange(checked)}
                      />
                    </Col>
                  </Row>
                </If>
                <Row>
                  <Col xs={12} sm={6} lg={3}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.name}
                      floatingLabelFixed
                      floatingLabelText="Nome Fantasia *"
                      onChange={(_, value) => (company.name = value)}
                      errorText={errors.name}
                    />
                  </Col>
                  <Col xs={12} sm={6} lg={3}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.slug}
                      floatingLabelFixed
                      floatingLabelText="Apelido"
                      onChange={(_, value) => (company.slug = value)}
                      errorText={errors.slug}
                    />
                  </Col>
                  <Col xs={12} sm={6} lg={3}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.fiscal_informations.legal_name}
                      floatingLabelFixed
                      floatingLabelText="Razão Social *"
                      onChange={(_, value) =>
                        (company.fiscal_informations.legal_name = value)
                      }
                      errorText={errors["fiscal_informations.legal_name"]}
                    />
                  </Col>
                  <Col xs={12} sm={6} lg={3}>
                    <TextField
                      maskPattern={[
                        /\d/,
                        /\d/,
                        ".",
                        /\d/,
                        /\d/,
                        /\d/,
                        ".",
                        /\d/,
                        /\d/,
                        /\d/,
                        "/",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        "-",
                        /\d/,
                        /\d/
                      ]}
                      fullWidth
                      underlineShow={false}
                      value={company.fiscal_informations.cnpj}
                      floatingLabelFixed
                      floatingLabelText="CNPJ *"
                      onChange={(_, value) => this.handleCnpjChange(value)}
                      errorText={errors["fiscal_informations.cnpj"]}
                    />
                  </Col>
                  <Col xs={12}></Col>
                </Row>
                <Row>
                  <Col xs={12} lg={6}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.fiscal_informations.ie}
                      maxLength={14}
                      floatingLabelFixed
                      floatingLabelText="Inscrição Estadual *"
                      onChange={(_, value) =>
                        (company.fiscal_informations.ie = value)
                      }
                      errorText={errors["fiscal_informations.ie"]}
                    />
                  </Col>
                  <Col xs={12} lg={6}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.fiscal_informations.im}
                      floatingLabelFixed
                      floatingLabelText="Inscrição Municipal"
                      onChange={(_, value) =>
                        (company.fiscal_informations.im = value)
                      }
                      errorText={errors["fiscal_informations.im"]}
                    />
                  </Col>
                  <Col xs={12}></Col>
                </Row>
                <Row>
                  <Col xs={12} lg={6}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.email}
                      floatingLabelFixed
                      floatingLabelText="E-mail"
                      onChange={(_, value) => (company.email = value)}
                      errorText={errors.email}
                    />
                  </Col>
                  <Col xs={12} lg={6}>
                    <TextField
                      maskPattern={[
                        "(",
                        /\d/,
                        /\d/,
                        ")",
                        " ",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        "-",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]}
                      fullWidth
                      underlineShow={false}
                      value={company.phone}
                      floatingLabelFixed
                      floatingLabelText="Telefone *"
                      onChange={(_, value) => (company.phone = value)}
                      errorText={errors.phone}
                    />
                  </Col>
                  <Col xs={12}></Col>
                </Row>
              </div>
            </Loadable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CompanyFormGeneralInfo;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/general-info/general-info.view.jsx